import React, { useRef, useState } from 'react'
import { Input, Table } from 'antd'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/user'
import { MemberInfoProps } from './interface'
import { columns } from './config'
import './index.less'

type PageProps = { pageNum: number; pageSize: number }

export default function MemberInfo(props: MemberInfoProps) {
  const [keyWord, setKeyWord] = useState('')
  const [total, setTotal] = useState(0)
  const [enterpriseQuota, setEnterpriseQuota] = useState(0)
  const pageRef = useRef<PageProps>({ pageNum: 1, pageSize: 10 })

  /*个人帐号信息-个人信息 */
  const {
    run: queryUserRelationUsingPOST,
    data,
    loading,
  } = useRequest(async (params = {}) => {
    const { data } = await api.queryUserRelationUsingPOST({
      keyWord,
      ...pageRef.current,
      ...params,
    })
    setTotal(data?.total)
    setEnterpriseQuota(data?.enterpriseQuota)
    return data?.otherUserInfos
  })

  return (
    <div className="id-member-info">
      <p className="member-info-a">
        企业当前可用总额度：{enterpriseQuota?.toFixed(2)}
      </p>
      <Input.Search
        value={keyWord}
        className="member-info-s"
        placeholder="搜索员工账号编码/员工电话"
        onChange={e => setKeyWord(e.target.value)}
        onSearch={() => {
          pageRef.current.pageNum = 1
          pageRef.current.pageSize = 10
          queryUserRelationUsingPOST({ keyWord })
        }}
      />
      <Table
        loading={loading}
        className="member-info-table"
        columns={columns}
        dataSource={data || []}
        pagination={{
          total,
          current: pageRef.current.pageNum,
          pageSize: pageRef.current.pageSize,
          showQuickJumper: true,
          showTotal: total => `总数 ${total} 条`,
          onChange(page, pageSize) {
            pageRef.current.pageNum = page
            pageRef.current.pageSize = pageSize
            queryUserRelationUsingPOST()
          },
        }}
      />
    </div>
  )
}
